<template>
  <a-box>
    <l-rows>
      <a-title
        :size="4"
        :text="$t('casinos.adapterConfiguration')"
      />
      <m-input
        v-for="(configVariable, index) in configVariables"
        :key="configVariable.key"
        :label="$t('casinos.' + configVariable.key)"
        :value="configVariable.value"
        @input="handleInput(index, $event)"
      />
    </l-rows>
  </a-box>
</template>

<script>

  import { MInput, ABox, ATitle, LRows } from 'codefabrik-gui-vue'

  export default {
    name: 'AdapterConfiguration',
    components: { MInput, ABox, ATitle, LRows },
    props: {
      configVariables: {
        type: Array,
        default: null
      },
    },
    methods: {
      handleInput (index, value) {
        this.configVariables[index].value = value
        this.$emit('configChange', [...this.configVariables])
      }
    }
  }
</script>
